// @flow
import React, { useState } from "react";
import { Card, CardTitle, FormGroup, Table } from "reactstrap";

import Gallery from "../components/Gallery";

import { templateAttributes } from "../../constants/templateAttributes";
import categoryService from "../../services/api/categoryService";

import { normalizeString } from "../../services/utils";

export function TemplateView(props) {
  const { template, actions } = props;

  const templateKeys = Object.keys(template);
  let files = [];
  for (let i = 0; i < templateKeys.length; i++) {
    if (Array.isArray(template[templateKeys[i]])) {
      files = [...files, ...template[templateKeys[i]]];
    } else {
      files = [...files, template[templateKeys[i]]];
    }
  }

  // Filtering out images to be displayed in the gallery component
  files = files.filter(
    fileName =>
      fileName &&
      (fileName.toString().includes(".png") ||
        fileName.toString().includes(".jpg") ||
        fileName.toString().includes(".jpeg") ||
        fileName.toString().includes(".mp4"))
  );

  const tableRows = Object.keys(template)
    .sort()
    .map(attribute => {
      if (attribute === "category") {
        return (
          <tr>
            <th>Category</th>
            <td style={{ fontWeight: "normal" }}>{template[attribute].name}</td>
          </tr>
        );
      }
      if (templateAttributes.includes(attribute))
        return (
          <tr>
            <th>{normalizeString(attribute)}</th>
            <td style={{ fontWeight: "normal" }}>
              {template[attribute].toString()}
            </td>
          </tr>
        );
      return null;
    });

  return (
    <Card outline color="dark" className="card-black p-3 m-3 col-md-11">
      <CardTitle className="d-flex justify-content-center">
        <b>{normalizeString(template.templateName)}</b>
      </CardTitle>
      <Gallery title="Images" id={template.id} files={files} />
      <div className="table table-responsive">
        <Table>
          <tbody>{tableRows}</tbody>
        </Table>
      </div>
      <FormGroup check row className=" mb-3 d-flex justify-content-center">
        {actions}
      </FormGroup>
    </Card>
  );
}
export default TemplateView;



// WEBPACK FOOTER //
// ./src/views/template/templateView.jsx